import PropTypes from 'prop-types';
import LanguageItem from '../../components/LanguageItem';
import useUniqueKeys from '../../hooks/useUniqueKeys';


const RenderLanguage = ({ fields }) => {
  const languages = fields.value || [];
  const [onDelete, modFields, setWasDeleted] = useUniqueKeys(languages);
  const handleFieldDelete = (id, index) => {
    fields.remove(index);
    onDelete(id);
  };

  const handleFieldAdd = () => {
    fields.push({});
    setWasDeleted(false);
  };

  return (
    <>
      {modFields.map(({ id }, index) => (
        <LanguageItem
          key={id}
          member={`languages[${index}]`}
          onDelete={() => handleFieldDelete(id, index)}
        />
      ))}
      <button
        type="button"
        className="button button_plus"
        onClick={handleFieldAdd}
      >
        <span className="button-icon">+</span>
        <span className="button-text">Добавить язык</span>
      </button>
    </>
  );
};

RenderLanguage.propTypes = {
  fields: PropTypes.object.isRequired,
};

export default RenderLanguage;
